<template>
  <div class="bg-white home-page flex-row">
    <div class="left">
      <div class="mode-list">
        <div class="mode-item" v-for="(item, index) in tmpArray" @click="modeToggleBtn(item, index)" :key="item.id"
          :class="{ active: modeIndex === index }">
          <div class="info-title">{{ item.modelTitle }}</div>
          <div class="info-box">
            <img :src="item.modelImg" class="mode-img" alt="">
            {{ item.modelCall }}
          </div>
        </div>
      </div>
    </div>
    <div class="right flex-1">
      <!-- <div class="tab-box flex-row">
				<div class="tab-item" :class="{active:tabIndex===0}" @click="tabBtn(0)">文字模式</div>
				<div class="tab-item" :class="{active:tabIndex===1}" @click="tabBtn(1)">绘画模式</div>
			</div> -->
      <!-- 聊天模式 -->
      <div class="chat-box no-scroll-bar" v-if="tabIndex === 0" id="chatBox">
        <template v-for="item in chatList" :key="item.id">
          <div class="chat-item" :class="{ 'self-info': item.self }">
            <img :src="item.avatar" class="avatar-img" alt="">
            <div class="chat-content">
              <!-- <div v-if="item.isList" class="chat-info">
								<div v-for="(its,index) in item.contentList" :class="{'markdown-box':its.isCode}" :key="index">
									<highlightjs v-if="its.isCode"  language='javascript' :code="its.content"></highlightjs>
									<div v-else v-html="its.content"></div>
								</div>
							</div>
							<div class="chat-info" v-html="item.content"></div>
							<div class="chat-tool" v-if="!item.self && item.isEnd">
								<span class="copy-btn" @click="copyBtn(contentB)" >复制</span>
							</div> -->
              <div class="chat-info" v-html="item.content"></div>
            </div>
          </div>
        </template>
      </div>
      <!-- 绘图模式 -->
      <div class="chat-box no-scroll-bar" v-if="tabIndex === 1" id="chatBox">
        <template v-for="item in paintList" :key="item.id">
          <div class="chat-item" :class="{ 'self-info': item.self }">
            <img :src="item.avatar" class="avatar-img" alt="">
            <div class="chat-content">
              <div class="chat-info" v-if="item.type == 1" v-html="item.content"></div>
              <div class="chat-info" v-if="item.type == 2">
                <img :src="item.content" class="chat-img" alt="">
              </div>
              <div class="chat-tool" v-if="!item.self && item.isEnd">
                <span class="copy-btn" @click="copyBtn(item.content)">复制</span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- SD绘图模式 -->


      <div class="chat-input-box">
        <el-backtop target=".chat-box" :bottom="240">
          <div class="top-bar flex-row flex-center">
            <i-ep-caret-top class="icon-top"/>
          </div>
        </el-backtop>
        <div class="">
          <div class="chat-model-box" @click="chatBtn">{{ isChat4 ? 'chat-4.0' : 'chat-3.5' }}</div>
          <el-input type="textarea" class="chat-input-textarea" v-model="content" :rows="4" placeholder="想要和我聊些什么？"
            @keyup.ctrl.enter="sendBtn"></el-input>
        </div>
        <div class="flex-row mt-12 flex-end">
          <!-- <div class="paint-btn flex-btn flex-center primary" @click="tabBtn(1)" v-if="tabIndex===0">
						<Picture  class="icon-paint" />
						绘图模式
					</div>
					<div class="paint-btn flex-btn flex-center primary"  @click="tabBtn(0)" v-else-if="tabIndex === 1">
						<Document class="icon-paint" />
						文字模式
					</div> -->
          <div class="paint-btn flex-btn primary send-btn" :class="{ disabled: !isEnd }" @click="sendBtn">发送</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { globalData } from '@/store/store.js'
import aiAvatar from '@/assets/img/logo.png'
// import avatar from '@/assets/img/avatar.jpeg'
import { marked } from "marked";
import { ref, reactive, onMounted, onUnmounted } from 'vue';
import { queryAiModel, cleanHistory, getUserInfo } from '@/http/http.js'
import env from '@/utils/env.js';
import { copyContent } from '@/utils/utils.js';
import hljs from 'highlight.js'
// import 'highlight.js/styles/atom-one-dark.css' // 代码高亮样式
let store = globalData(), wssIsConnect = true;
const aiUser = reactive({ avatar: aiAvatar, nickName: '小助手' });
const modeIndex = ref(0), modelId = ref('');
//切换聊天模式
const tabIndex = ref(0);
const isChat4 = ref(false);
const tabBtn = (index) => {
  tabIndex.value = index
}
const baseImgDomain = ref(env.IMAGE_URL)

marked.setOptions({
  renderer: new marked.Renderer(),
  highlight: function (code, lang) {
    try {
      if (lang) {
        return hljs.highlight(code, { language: lang }).value
      } else {
        return hljs.highlightAuto(code).value
      }
    } catch (error) {
      return code
    }
  },
  langPrefix: 'hljs', // highlight.js css expects a top-level 'hljs' class.
  pedantic: false,
  gfm: true,
  breaks: false,
  sanitize: false,
  smartLists: true,
  smartypants: false,
  xhtml: false
});

function chatBtn() {
  cleanHistory();//切换3.5和4.0的时候请一下聊天记录 免得3.5的影响4.0回答
  isChat4.value = !isChat4.value
}
const modeToggleBtn = (data, index) => {
  if (modeIndex.value == index) {
    return false;
  }
  modeIndex.value = index;
  aiUser.avatar = data.modelImg;
  aiUser.nickName = data.modelTitle;

  // maskVisible.value = false;
  let { modelImg: avatarImg, modelTitle: modelRole, modelCall: content, id } = data;
  modelId.value = id;
  chatList.push({
    avatar: avatarImg,
    modelRole,
    content,
    id: + new Date(),
    self: 0,
  })
  cleanHistory();
}
const tmpArray = reactive([]);
let avatar = '';
onMounted(() => {
  let pid = functiongetQueryString('pid');
  if (pid) {
    localStorage.pid = pid
  }
  queryAiModel().then(res => {
    res.data.map(it => {
      if(!it.modelImg.startsWith(baseImgDomain.value)){
        it.modelImg = baseImgDomain.value + it.modelImg
      }
      it.modelContent = it.modelContent.replace('你', '我');
    })
    tmpArray.push(...res.data);
  })
  if (token) {
    getUserInfo(null, false).then(res => {
      avatar = res.data.avatar
    })
  }
});

let token = localStorage.token;
const contentB = ref('')
let ws = new WebSocket(env.wss + '/api/websocket/' + token);
const content = ref('');

let heartCheck = null;
ws.onopen = (data) => {
  console.log('wss open');
  heartCheck = setInterval(function () {
    ws.send('heartbeat');
  }, 5000);  // 发送心跳消息的时间间隔，单位毫秒
}
let isEnd = ref(true), timeAfter = +new Date();
ws.onmessage = (msg) => {
  // console.log('on message',msg.data);
  if (msg.data == 'heartbeat') {
    return false;
  }
  wssIsConnect = true;
  isEnd.value = false;

  let data = msg.data;
  if (data == '\n') {
    data = '<br/>';
  }
  let currTime = +new Date();
  if (currTime - timeAfter > 1000) {
    timeAfter = +new Date();
    scrollBottom()
  }
  let lastItem = chatList[chatList.length - 1];
  if (data === '[DONE]') {
    isEnd.value = true;
    let content = lastItem.content, contentArr = content.split('```');
    lastItem.isEnd = true;
    setTimeout(scrollBottom, 500);
  } else {
    // console.log(chatList[chatList.length-1])
    if (lastItem.content === '正在思考中...') {
      contentB.value = msg.data;
    } else {
      contentB.value = contentB.value + msg.data;

    }
  }
  lastItem.content = marked(contentB.value)

  if (data === '[DONE]') {
    // hljs.initHighlighting()
    hljs.highlightAll();
  }

}
onUnmounted(() => {
  clearInterval(heartCheck);
  ws.close();
})
const chatList = reactive([]);

const scrollBottom = () => {
  let chatHistory = document.getElementById('chatBox');
  // console.log('scroll bottom');
  if (chatHistory.scrollHeight > chatHistory.clientHeight) {
    setTimeout(function () {
      //设置滚动条到最底部
      chatHistory.scrollTop = chatHistory.scrollHeight;
    }, 0);
  }
}
function chatModel() {
  wssIsConnect = false;
  //isChat4 true 表示chat-4.0 false chat3.5
  ws.send(JSON.stringify({ msg: content.value, modelId: modelId.value, gptType: isChat4.value }));
  chatList.push({
    avatar: avatar,
    self: 1,
    content: content.value,
    id: +new Date(),
    isCode: 0,
  })
  chatList.push({
    avatar: aiUser.avatar,
    self: 0,
    content: '正在思考中...',
    id: +new Date(),
    isList: false,
    type: 1,
  })
  content.value = '';
  setTimeout(() => {
    if (!wssIsConnect) {
      ElMessage.warning('wss链接超时');
      location.reload();
    }
  }, 30000)
}
const paintList = reactive([]);
const functiongetQueryString = (name) => {
  let geturl = window.location.href
  let getqyinfo = geturl.split('?')[1]   //qycode=1001&qyname=%E4%BC%81%E4%B8%9A%E5%BF%99   截取到参数部分
  let getqys = new URLSearchParams('?' + getqyinfo)  //将参数放在URLSearchParams函数中
  return getqys.get(name);
}
const sendBtn = (data) => {
  if (!content.value) {
    return ElMessage.warning('请输入聊天内容')
  }
  contentB.value = ''
  console.log('send btn', content.value);
  chatModel();

}

const copyBtn = (item) => {
  copyContent(item);
}
</script>
<style lang="scss">
.chat-info {
  table {
    border: 1px solid #333;

    td,
    th {
      border: 1px solid #333;
      padding: 8px;
    }
  }
}
</style>
<style lang="scss" scoped>
.home-page {
  .left {
    height: calc(100vh - 110px);
    border-right: 1px solid #EFEFEF;
    width: 30%;
    padding: 20px;
  }

  .position-box {
    position: relative;

    .chat-model-box {
      position: absolute;
      top: -56px;
      left: 0px;
      padding: 5px 12px;
      border-radius: 5px;
      background: linear-gradient(135deg, #128D8F, #129D79);
      color: #FFF;
      cursor: pointer;
    }

  }

  .tab-box {
    .tab-item {
      width: 200px;
      text-align: center;
      position: relative;
      height: 30px;
      cursor: pointer;

      &:hover {
        &::after {
          width: 80px;
        }
      }

      &::after {
        position: absolute;
        content: "";
        display: block;
        width: 0px;
        height: 2px;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        background-color: $blue;
        transition: width .2s;
      }

      &.active {
        &::after {
          width: 80px;
        }
      }
    }
  }

  .mode-list {
    height: 100%;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 0px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 0px;
      background: transparent;
    }

    &::-webkit-scrollbar-track {
      border-radius: 0;
      background: transparent;
    }
  }

  .markdown-box {
    background-color: #FFFFFF;
    padding: 5px;
    margin: 10px 0;
    overflow-x: scroll;
  }

  .mode-item {
    padding: 12px;
    padding-left: 70px;
    background-color: #F5F5F5;
    border-radius: 10px;
    cursor: pointer;

    &+.mode-item {
      margin-top: 16px;
    }

    &:hover {
      background-color: rgba($blue, .1);
    }

    .info-title {
      font-size: 16px;

    }

    &.active {
      background-color: rgba($blue, .1);

      .info-title {
        color: $blue;
      }
    }


    .info-box {
      position: relative;
      color: #666666;
      font-size: 13px;
      line-height: 18px;
      margin-top: 4px;
      min-height: 40px;

      .mode-img {
        position: absolute;
        width: 48px;
        height: 48px;
        left: -60px;
        top: -22px;
        object-fit: contain;
        border-radius: 4px;
      }
    }

  }



}

.right {
  padding: 12px 20px;
  display: flex;
  flex-direction: column;

  .chat-box {
    height: calc(100vh - 360px);
    margin-bottom: 20px;
  }
}

.chat-item {
  display: flex;
  width: 100%;

  &+.chat-item {
    margin-top: 12px;
  }

  &.self-info {
    flex-direction: row-reverse;

    .avatar-img {
      margin-left: 20px;
      margin-right: 0px;
    }

    .chat-info {
      border-radius: 12px 0px 12px 12px;
    }

    .chat-tool {
      text-align: right;
      padding-right: 20px;
    }

  }


  .avatar-img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 20px;
  }

  .chat-info {
    background-color: #F5F5F5;
    border-radius: 0px 12px 12px 12px;
    padding: 12px 20px;
    max-width: 100%;
  }

  .chat-tool {
    margin-top: 4px;
    padding-left: 20px;

    .copy-btn {
      color: #666666;
      cursor: pointer;

      &:hover {
        color: #333333;
      }
    }
  }
}

.chat-input-box {
  background-color: #F5F5F5;
  padding: 20px;
  border-radius: 10px;

  .paint-btn {
    background-color: $blue;
    color: #FFF;
    width: 120px;
    height: 40px;
    font-size: 16px;
    letter-spacing: 2px;

    &:hover {
      background-color: rgba($blue, .85);
    }

    .icon-paint {
      margin-right: 8px;
      width: 20px;
      height: 20px;
    }

    &.send-btn {
      width: 80px;

      &.disabled {
        opacity: .5;
      }
    }
  }

  .chat-input-textarea {
    background-color: #F5F5F5;

    :deep textarea {
      background-color: transparent;
      border: none;
    }
  }
}

.top-bar {
  height: 100%;
  width: 100%;
  background-color: #f2f5f6;
  box-shadow: 0 0 6px rgba(0, 0, 0, .12);
  border-radius: 50%;

  .icon-top {
    width: 20px;
    height: 20px;
  }
}
</style>